import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy‑load page components
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const EUProjectsPage = lazy(() => import('../pages/eu-projects/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

/**
 * Route configuration for the application.
 * Each route's `element` property contains a lazily‑loaded component.
 * The surrounding `React.Suspense` (usually placed in the router
 * rendering layer) will handle the loading state.
 */
const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/o-firmie',
    element: <AboutPage />,
  },
  {
    path: '/uslugi',
    element: <ServicesPage />,
  },
  {
    path: '/realizacje',
    element: <GalleryPage />,
  },
  {
    path: '/kontakt',
    element: <ContactPage />,
  },
  {
    path: '/polityka-prywatnosci',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/projekty-ue',
    element: <EUProjectsPage />,
  },
  {
    // Catch‑all route for 404 pages
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
